var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViapointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0L17 33",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17L4.17233e-07 17",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16.7938C29 23.2924 23.6425 28.5877 17 28.5877C10.3575 28.5877 5 23.2924 5 16.7938C5 10.2953 10.3575 5 17 5C23.6425 5 29 10.2953 29 16.7938Z",
    fill: "white",
    stroke: "#FF7200",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 22.091C17.3593 22.091 17.199 22.0477 17.069 21.961C16.9477 21.8657 16.848 21.727 16.77 21.545L13.273 13.628C13.2037 13.446 13.1863 13.29 13.221 13.16C13.2557 13.03 13.325 12.9303 13.429 12.861C13.5417 12.783 13.676 12.744 13.832 12.744C14.0313 12.744 14.183 12.7873 14.287 12.874C14.391 12.9607 14.4777 13.0907 14.547 13.264L17.823 20.856H17.342L20.592 13.251C20.67 13.0863 20.761 12.9607 20.865 12.874C20.9777 12.7873 21.1293 12.744 21.32 12.744C21.476 12.744 21.6017 12.783 21.697 12.861C21.801 12.9303 21.866 13.03 21.892 13.16C21.918 13.29 21.892 13.446 21.814 13.628L18.33 21.545C18.252 21.727 18.1523 21.8657 18.031 21.961C17.9097 22.0477 17.7493 22.091 17.55 22.091Z",
    fill: "#FF7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViapointIcon);
export default __webpack_public_path__ + "static/media/viapoint_icon.fe39fc102200296fbf272e694ae0ffa2.svg";
export { ForwardRef as ReactComponent };